import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { EnterpriseMoneyPage } from "@/components/site/EnterpriseMoneyPage";
import { MexicoMarketSignal } from "@/components/site/MexicoMarketSignal";
import { SHOPIFY_PLUS_FAQS } from "@/lib/service-content/faqs/shopify-plus";
import {
  buildHead,
  breadcrumbJsonLd,
  faqJsonLd,
  serviceJsonLd,
} from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/agencia-shopify-plus";
const ALT = "/shopify-plus-agency";
const TITLE = "Agencia Shopify Plus en México | Desarrollo Shopify Plus · Shugert";
const DESC = "Agencia de desarrollo Shopify Plus para México y Latinoamérica. Shopify Select Partner con desarrolladores senior para storefronts, Functions, B2B, Markets, checkout, integraciones y replatforming.";

export const Route = createFileRoute("/es/agencia-shopify-plus")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: TITLE,
    description: DESC,
    path: PATH,
    altPath: ALT,
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Agencia Shopify Plus en México", path: PATH }]),
      faqJsonLd(SHOPIFY_PLUS_FAQS.es),
      serviceJsonLd({
        name: "Agencia de Desarrollo Shopify Plus en México",
        description: "Desarrollo e ingeniería Shopify Plus para marcas DTC y B2B en México y Latinoamérica: storefronts, Functions, B2B, Markets, checkout extensibility, integraciones y replatforming.",
        path: PATH,
        serviceType: "Agencia de Desarrollo Shopify Plus",
        minPrice: 15000,
        maxPrice: 75000,
        unit: "PROJECT",
        deliverables: [
          "Desarrollo de storefront y theme Shopify Plus",
          "Shopify Functions para descuentos, envíos y pagos",
          "Catálogos B2B, listas de precios y términos",
          "Implementación multi-región y multi-moneda con Markets",
          "Checkout extensibility y datos de eventos del cliente",
          "Replatforming desde Magento, BigCommerce y WooCommerce",
        ],
        locale: "es",
      }),
    ],
  }),
  component: () => (
    <SiteShell>
      <EnterpriseMoneyPage locale="es" />
      <MexicoMarketSignal
        title="Shopify Plus para marcas en México que necesitan algo más que una implementación estándar."
        body="Trabajamos con equipos DTC y B2B en México y Latinoamérica que necesitan conectar Shopify Plus con su operación real: ERP, PIM, logística, pagos, B2B, Markets y procesos internos. El mismo equipo senior define la arquitectura, desarrolla la solución y acompaña el lanzamiento para evitar que cada integración quede aislada o dependa de un proveedor distinto."
        links={[
          { label: "Migración a Shopify", href: "/es/migracion-shopify" },
          { label: "Desarrollo Shopify", href: "/es/desarrollo-shopify" },
          { label: "Servicios Shopify", href: "/es/servicios" },
        ]}
      />
    </SiteShell>
  ),
});
